import React from 'react';
import { Form, Field } from 'react-final-form';
import { Text, Box, RadioField } from 'mdlkit';
import { StyledForm, FormSubmitLoadingButton } from '../shared/Styles';
import { MultiplePhoneNumbersUser } from '../../interfaces/login';

interface Props {
  users: MultiplePhoneNumbersUser[];
  onSubmit: (values: any) => void;
}

const MultiplePhoneNumbersForm = ({ users, onSubmit }: Props) => {
  const [firstUser] = users;
  const initialValues = { token: `${firstUser.token}` };
  return (
    <Form
      onSubmit={onSubmit}
      initialValues={initialValues}
      render={({ handleSubmit, submitting, valid }) => (
        <StyledForm onSubmit={handleSubmit} spellCheck={false}>
          <Box width="100%" textAlign="left">
            <Text mb="sm">
              Please select a phone to send the verification code
            </Text>
            {users.map(({ token, phone }) => (
              <Box key={token} mb="sm">
                <Field
                  id={`token-${token}`}
                  type="radio"
                  label={phone}
                  name="token"
                  component={RadioField}
                  value={`${token}`}
                />
              </Box>
            ))}
          </Box>
          <FormSubmitLoadingButton
            id="accountRecoveryBtn"
            type="submit"
            size="large"
            disabled={submitting || !valid}
            isLoading={submitting}
            data-track-event
            data-track={JSON.stringify({
              controlName: 'forgot-username-select-recovery-number-send-code',
              controlText: 'Send Code',
            })}
          >
            Send code
          </FormSubmitLoadingButton>
        </StyledForm>
      )}
    />
  );
};

export default MultiplePhoneNumbersForm;
